var mktheme = {
    productInfo: document.querySelector('.product__info-wrapper'),
    productMedia: document.querySelector('.product__media-wrapper'),
    announcementBar: document.querySelector('.announcement-bar__message'),
    magicToolboxContainer: document.querySelector('.MagicToolboxContainer')
};
mktheme = {...mktheme, ...{
    infoRect: mktheme.productInfo.getBoundingClientRect(),
    mediaRect: mktheme.productMedia.getBoundingClientRect(),
    announceRect: mktheme.announcementBar.getBoundingClientRect(),
    magicRect: mktheme.magicToolboxContainer.getBoundingClientRect()
}};
var lastScroll = window.scrollY;
var mediaFixedScroll = (e)=>{
    if (mktheme.productInfo.offsetY == mktheme.productMedia.offsetY && window.innerWidth >= 750) {
        var scrollDir = (lastScroll < window.scrollY) ? "1" : "0";
        lastScroll = window.scrollY;

        visibleRange = window.innerHeight - mktheme.announceRect.height;
        offsetTop = visibleRange - mktheme.magicRect.height;
        offsetTop = (offsetTop < 0) ? offsetTop : 0;
        topLimit = mktheme.productMedia.offsetTop - mktheme.announceRect.height - 10 - offsetTop * scrollDir;
        bottomLimit = topLimit + mktheme.infoRect.height - mktheme.magicRect.height - offsetTop * scrollDir;
        scrollRange = mktheme.infoRect.height - mktheme.magicRect.height;

        // console.log({scroll:window.scrollY,visibleRange,offsetTop,topLimit,bottomLimit,scrollRange});
        if (window.scrollY > topLimit && window.scrollY < bottomLimit) {
            // console.log("ACTIVATE SCROLL POWERS!");
            topMargin = window.scrollY - topLimit;
            mktheme.magicToolboxContainer.style.marginTop = `${topMargin}px`;
        } else {
            // console.log("INGORE SCROLL POWERS!");
        }
    }
}
window.addEventListener('scroll',mediaFixedScroll);